import React, { SVGProps } from "react";
export default function SupReset(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2655 18C16.5792 18 19.2655 15.3137 19.2655 12C19.2655 8.68629 16.5792 6 13.2655 6C10.2103 6 7.68841 8.28357 7.31358 11.237L7.30015 11.25H9.79661L6.76552 15L3.73444 11.25H6.30523C6.67946 7.73668 9.6529 5 13.2655 5C17.1315 5 20.2655 8.13401 20.2655 12C20.2655 15.866 17.1315 19 13.2655 19C11.0432 19 9.0628 17.9644 7.78049 16.3495L8.50345 15.6505C9.6002 17.0791 11.3253 18 13.2655 18ZM5.82855 12.25L6.76552 13.4092L7.7025 12.25H5.82855Z"
        fill="currentColor"
      />
    </svg>
  );
}
